import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { QuestionDTO } from '@/models/QuestionDTO';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton';
import InputText from '@/components/inputs/InputText/InputText';
import InputDate from '@/components/inputs/InputDate/InputDate';
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox';
import moment from 'moment';
import { WatchOptions } from 'vue';
import InputNumber from '@/components/inputs/InputNumber/InputNumber';

@Component({
  name: 'Question',
  components: {
    InputRadioButton,
    InputText,
    InputCheckbox,
    InputDate,
    InputNumber,
  },
})
export default class Question extends Vue {
  @Prop() public booleanType?: string; // can be either "radioButton" or "checkbox"
  @Prop() private question: QuestionDTO | undefined;
  @Prop({ default: false }) private readonly?: boolean;

  private minDate?: string;
  private maxDate?: string;
  private minMonth?: number;
  private maxMonth?: number;

  // called by InputCheckbox component
  public changeAnswer(checked: boolean) {
    if (this.question !== undefined) {
      this.question.answer = checked === true ? '1' : '0';
    }
  }

  public onIsInputNumberValid(value: boolean): void {
    this.$emit('is-input-number-valid', value);
  }

  @Watch('question', { immediate: true, deep: true } as WatchOptions)
  protected onQuestionChange(value: QuestionDTO, oldvalue: QuestionDTO) {
    if (oldvalue !== value && value !== undefined) {
      if (value.validator === 'coloscopiedaterange'
      && value.validatorConfigItem && value.validatorConfigItem.value !== undefined) {
        const years = Number(value.validatorConfigItem.value as string);
        this.minDate = moment().subtract(years, 'years').format('YYYY-MM-DD');
        this.maxDate = moment().format('YYYY-MM-DD');
      } else {
        this.maxDate = undefined;
        this.minDate = undefined;
      }

      if (value.validator === 'reinvitMonthsRange'
      && value.validatorConfigItem && value.validatorConfigItem.value !== undefined) {
        this.minMonth = 1;
        this.maxMonth = Number(value.validatorConfigItem.value);
      } else {
        this.maxMonth = undefined;
        this.minMonth = undefined;
      }
    }
  }
}
